/**
파일명: App.js
설명: 앱의 최상위 조립 지점으로 라우팅 상태와 공통 레이아웃/페이지 라우터를 연결합니다.
*/

import { useAppRouter } from './hooks/useAppRouter';
import MainLayout from './layouts/MainLayout';
import PageRouter from './pages/PageRouter';

export default function App() {
  // [비즈니스] URL 변경에 따라 올바른 페이지를 노출해 사용자의 탐색 흐름을 유지합니다.
  // [기능] 라우팅 훅에서 현재 경로, 파싱된 라우트, 이동 함수를 조회합니다.
  // [기술] 파생 상태(route)를 useAppRouter 내부에서 계산해 App은 조립 책임만 유지합니다.
  const { pathname, route, navigate } = useAppRouter();

  return (
    <MainLayout pathname={pathname} onNavigate={navigate}>
      <PageRouter route={route} onNavigate={navigate} />
    </MainLayout>
  );
}
